/**
 * Image paths from the API are either site-relative ("/img/boat/12_x.jpg", served by the assets CDN)
 * or absolute (pictures imported from the charter systems into the media bucket). Prefix only the
 * relative ones.
 */
export const ASSETS_HOST = 'https://assets.theyachtweek.com';

const isAbsolute = path => /^(https?:)?\/\//i.test(path);

export const imageUrl = (path, host = ASSETS_HOST) => {
  if (!path) {
    return '';
  }
  return isAbsolute(path) ? path : `${host}${path}`;
};

export default imageUrl;
